<template>
  <div class="main-content">
    <div>
      <v-card shaped outlined tile>
        <v-row class="mt-3 mx-3 mb-n3" no-gutters>
          <v-col md="8">
            <v-form autocomplete="off">
              <v-row no-gutters>
                <v-text-field
                  @keydown.enter.prevent="pesquisar()"
                  style="border-top-left-radius: 15px; width: 325px; max-width: 325px"
                  class="fs-searchfield"
                  label="Pesquisar"
                  placeholder=" "
                  spellcheck="false"
                  v-model="textoPesquisa"
                  append-icon="mdi-magnify"
                  @click:append="pesquisar()"
                  outlined
                  dense
                />
                <v-btn
                  @click="dialogFiltros = true"
                  class="fs-btns-crud-grid"
                  style="margin-top: 2px"
                  height="32px"
                  outlined
                  small
                >
                  <v-icon class="mr-1">mdi-filter</v-icon>
                  Selecionar Filtros
                </v-btn>
                <v-btn v-if="filtroComposto.length > 1" @click="limparFiltros()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="error" outlined small>
                  <v-icon class="mr-1">mdi-filter-remove-outline</v-icon>
                  Limpar Filtros
                </v-btn>
                <v-btn @click="exportarExcel()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" outlined small>
                  <v-icon class="mr-1">mdi-file-excel</v-icon>
                  Exp. p/ Excel
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-spacer></v-spacer>
          <div class="fs-topbar-right">
          </div>
        </v-row>

        <v-dialog width="400px" v-model="dialogExcel">
          <v-card>
            <v-card-title>
              Seu arquivo está pronto!
            </v-card-title>
            <v-card-text>
              Faça o download clicando no botão abaixo.
            </v-card-text>
            <v-divider class="ma-0 "/>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#2A2F50" download="report.csv" :href="linkExcel" @click="dialogExcel = false" dark small>
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>
                Fazer Download
              </v-btn>
              <v-btn color="warning" @click="dialogExcel = false" dark small>
                <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogFiltros" width="450px">
          <v-card>
            <v-btn @click="dialogFiltros = false" style="position: absolute; right: 0; top: 0" icon>
              <v-icon style="font-size: 25px !important">mdi-close</v-icon>
            </v-btn>
            <v-form autocomplete="off">
              <v-card-title>Filtros Específicos</v-card-title>
              <v-divider class="mt-n1 mb-n3"/>
              <v-card-text>
                <v-row class="px-2 pb-1 fs-div-checkbox-filtro" no-gutters>
                  <v-col md="12">
                    <div class="mb-4">
                      <label class="fs-label-filtro">Intervalo de Datas</label>
                    </div>
                  </v-col>
                  <v-col md="5">
                    <v-menu
                      v-model="menuDataInicialFiltro"
                      :close-on-content-click="false"
                      :nudge-top="48"
                      :nudge-right="10"
                      transition="scale-transition"
                      max-width="290"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="mb-n5 mr-1"
                          :value="formatDataInicial"
                          append-outer-icon="mdi-calendar"
                          label="Data Inicial"
                          placeholder=" "
                          @click:clear="dataInicial = null"
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataInicial"
                        @change="menuDataInicialFiltro = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="5">
                    <v-menu
                      v-model="menuDataFinalFiltro"
                      :close-on-content-click="false"
                      :nudge-top="48"
                      :nudge-right="10"
                      transition="scale-transition"
                      max-width="290"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          class="mb-n5 ml-1"
                          :value="formatDataFinal"
                          append-outer-icon="mdi-calendar"
                          label="Data Final"
                          placeholder=" "
                          @click:clear="dataFinal = null"
                          v-on="on"
                          outlined
                          readonly
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dataFinal"
                        @change="menuDataFinalFiltro = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="2">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-switch
                          v-model="filtroData"
                          v-on="on"
                          class="mt-0 ml-5"
                          color="#2A2F50"
                          :value="true"
                          hide-details
                        ></v-switch>
                      </template>
                      <span style="font-size: 11px">
                        {{ filtroData ? 'FILTRO POR DATA ATIVADO' : 'FILTRO POR DATA DESATIVADO' }}
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <div class="fs-div-checkbox-filtro">
                  <v-row no-gutters>
                    <v-col>
                      <label class="fs-label-filtro">Tipo de Log</label>
                      <v-select
                        class="mr-1 mt-3 mb-2"
                        label="Tipo"
                        v-model="filtros.tipo"
                        item-text="text"
                        item-value="value"
                        height="32px"
                        :items="[
                          {text:'Campanha Manual', value:'1'},
                          {text:'Envio Automático', value:'2'},
                          {text:'Repetição de Pedido', value:'3'}
                        ]"
                        hide-details
                        placeholder=" "
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col>
                      <label class="fs-label-filtro">Resposta do Cliente</label>
                      <v-select
                        class="ml-1 mt-3 mb-2"
                        label="Resposta"
                        v-model="filtros.resposta"
                        item-text="text"
                        item-value="value"
                        height="32px"
                        :items="[{text:'Sem Interação', value:'0'}, {text:'Clicou Sim', value:'1'}, {text:'Clicou Não', value:'2'}, {text:'Solicitou Contato', value:'3'}, {text:'Finalizou Pedido', value:'4'}, {text:'Cancelou o Pedido', value:'5'}]"
                        hide-details
                        placeholder=" "
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </div>
                <div class="fs-div-checkbox-filtro">
                  <label class="fs-label-filtro">Status de Envio</label>
                  <v-row no-gutters>
                    <v-col>
                      <v-select
                        class="mr-1 mt-3 mb-2"
                        label="Status Email"
                        v-model="filtros.status_email"
                        item-text="text"
                        item-value="value"
                        height="32px"
                        :items="[{value:'0',text:'Sem Email'},{value:'1',text:'Pendente'},{value:'2',text:'Enviado'},{value:'3',text:'Erro'},{value:'4',text:'Ped.Compra'}]"
                        hide-details
                        placeholder=" "
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        class="ml-1 mt-3 mb-2"
                        label="Status WhatsApp"
                        v-model="filtros.status_whatsapp"
                        item-text="text"
                        item-value="value"
                        height="32px"
                        :items="[{value:'0',text:'Não Enviado'},{value:'1',text:'Pendente'},{value:'2',text:'Enviado'},{value:'3',text:'Erro'}]"
                        hide-details
                        placeholder=" "
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </div>
                <div class="fs-div-checkbox-filtro">
                  <label class="fs-label-filtro">Intervalo de Iniciais</label>
                  <v-row class="mt-3 mb-2" no-gutters>
                    <v-text-field
                      label="Caractere Inicial"
                      class="fs-text-field mr-2"
                      v-model="filtros.letrainicial"
                      placeholder="0 - Z"
                      hide-details
                      maxlength="1"
                      outlined
                      dense
                    />
                    <v-text-field
                      label="Caractere Final"
                      class="fs-text-field"
                      v-model="filtros.letrafinal"
                      placeholder="A - Z"
                      hide-details
                      maxlength="1"
                      outlined
                      dense
                    />
                  </v-row>
                </div>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="filtros = {}" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="warning" small>
                  <v-icon class="mr-1">mdi-close</v-icon>
                  Resetar Campos
                </v-btn>
                <v-btn @click="page = 1; filtrar()" class="fs-btns-crud-grid" style="margin-top: 2px" height="32px" color="primary" small>
                  <v-icon class="mr-1">mdi-refresh</v-icon>
                  Atualizar Filtros
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-divider />

        <v-data-table
          :loading="loading"
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="logs.data"
          :items-per-page="9999999"
          hide-default-footer
          hide-action
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr
              class="fs-tr-logs"
              v-for="item in items"
              :key="item.id"
            >
              <td>
                <v-chip
                  v-if="item.tipo === '1'"
                  color="success"
                  class="fs-chip"
                  small
                >
                  Campanha
                </v-chip>
                <v-chip
                  v-else-if="item.tipo === '2'"
                  color="warning"
                  class="fs-chip"
                  small
                >
                  Automático
                </v-chip>
                <v-chip
                  v-else-if="item.tipo === '3'"
                  class="fs-chip"
                  color="error"
                  small
                >
                  Repetição
                </v-chip>
              </td>
              <td>
                {{ item.campanha_id ? item.campanha : 'Envio Automatizado' }}
              </td>
              <td>
                {{ item.dthr_envio_email | formatData }}
              </td>
              <td>
                {{ item.cliente_nome }}
              </td>
              <td>
                {{ item.cliente_contato }}
              </td>
              <!-- <td>
                {{ item.cliente_telefone }}
              </td>
              <td>
                {{ item.cliente_celular }}
              </td> -->
              <td>
                {{ item.cliente_email }}
              </td>
              <td>
                <v-chip
                  v-if="item.status_email === '0'"
                  color="default"
                  class="fs-chip"
                  small
                >
                  Sem Email
                </v-chip>
                <v-chip
                  v-else-if="item.status_email === '1'"
                  color="warning"
                  class="fs-chip"
                  small
                >
                  Pendente
                </v-chip>
                <v-chip
                  v-else-if="item.status_email === '2'"
                  color="success"
                  class="fs-chip"
                  small
                >
                  Enviado
                </v-chip>
                <v-chip
                  v-else-if="item.status_email === '3'"
                  color="error"
                  class="fs-chip"
                  small
                >
                  Erro
                </v-chip>
                <v-chip
                  v-else-if="item.status_email === '4'"
                  color="error"
                  class="fs-chip"
                  small
                >
                  Ped.Compra
                </v-chip>
              </td>
              <td>
                <span v-if="item.status_whatsapp === '0'">
                  Não Enviado
                </span>
                <v-chip
                  v-else-if="item.status_whatsapp === '1'"
                  color="warning"
                  class="fs-chip"
                  small
                >
                  Pendente
                </v-chip>
                <v-chip
                  v-else-if="item.status_whatsapp === '2'"
                  color="success"
                  class="fs-chip"
                  small
                >
                  Enviado
                </v-chip>
                <v-chip
                  v-else-if="item.status_whatsapp === '3'"
                  color="error"
                  class="fs-chip"
                  small
                >
                  Erro
                </v-chip>
              </td>
              <!-- <td>
                {{ item.total_pedido }}
              </td> -->
              <td style="text-align: center">
                <v-chip
                  v-if="item.resposta === '0'"
                  color="white"
                  class="fs-chip"
                  small
                >
                  Sem Interação
                </v-chip>
                <v-chip
                  v-else-if="item.resposta === '1'"
                  color="#89c6ff"
                  style="color: white"
                  class="fs-chip"
                  small
                >
                  Clicou Sim
                </v-chip>
                <v-chip
                  v-else-if="item.resposta === '2'"
                  color="#8b8b8b"
                  style="color: white"
                  class="fs-chip"
                  small
                >
                  Clicou Não
                </v-chip>
                <v-chip
                  v-else-if="item.resposta === '3'"
                  color="warning"
                  class="fs-chip"
                  small
                >
                  Solicitou Contato
                </v-chip>
                <v-chip
                  width="100%"
                  v-else-if="item.resposta === '4'"
                  color="success"
                  class="fs-chip"
                  small
                >
                  Finalizou o Pedido
                </v-chip>
                <v-chip
                  v-else-if="item.resposta === '5'"
                  color="error"
                  class="fs-chip"
                  small
                >
                  Cancelou o Pedido
                </v-chip>
              </td>
              <td>
                <span v-if="item.dthr_interacao">
                  {{ item.dthr_interacao | formatData }}
                </span>
                <span v-else>
                  <v-chip
                    color="white"
                    class="fs-chip"
                    small
                  >
                    Sem Interação
                  </v-chip>
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>

        <v-row class="pl-4 pr-6 py-3" style="background-color: white" no-gutters>
          <v-col cols="12">
            <v-row align="center" justify="space-between">
              <v-card class="ml-3" flat>
                <v-btn-toggle
                  v-model="limit"
                  mandatory
                  group
                  dense
                >
                  <v-btn :value="20" class="fs-btn-limit">20</v-btn>
                  <v-btn :value="30" class="fs-btn-limit">30</v-btn>
                  <v-btn :value="50" class="fs-btn-limit">50</v-btn>
                  <v-btn :value="100" class="fs-btn-limit">100</v-btn>
                  <div v-if="logs.data" style="background-color: #EEEEEE; padding: 10px; margin: 5px; color: gray; font-size: 11px; letter-spacing: 1px">
                    {{ logs.total }} REGISTROS
                  </div>
                </v-btn-toggle>
              </v-card>
              <v-card flat>
                <v-pagination color="#2A2F50" v-model="page" :length="logs.lastPage"  circle total-visible="8"></v-pagination>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { list, list2, add, edit, del } from '@/api/crud' // eslint-disable-line
import { excelCampanhaLogs } from '@/api/campanha'

import moment from 'moment'

export default {
  data () {
    return {
      headers: [
        { text: 'TIPO', value: 'tipo' },
        { text: 'DESCRIÇÃO', value: 'campanha' },
        { text: 'DT/HR ENVIO', value: 'dthr_envio_email' },
        { text: 'CLIENTE', value: 'cliente_nome' },
        { text: 'CONTATO', value: 'cliente_contato' },
        // { text: 'TELEFONE' },
        // { text: 'WHATSAPP' },
        { text: 'E-MAIL', value: 'cliente_email' },
        { text: 'STAT. EMAIL', value: 'status_email' },
        { text: 'STAT. WHATS', value: 'status_whatsapp' },
        // { text: 'TOTAL', value: 'total_pedido' },
        { text: 'RESPOSTA', value: 'resposta', align: 'center' },
        { text: 'DT/HR INTERAÇÃO.', value: 'dthr_interacao' }
      ],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataFinal: false,
      menuDataFinalFiltro: false,
      menuDataInicial: false,
      menuDataInicialFiltro: false,
      logs: [],
      dialogFiltros: false,
      dialogExcel: false,
      linkExcel: null,
      filtroComposto: [],
      filtroData: false,
      filtros: {},
      textoPesquisa: '',
      loading: false,
      limit: 20,
      page: 1
    }
  },
  filters: {
    formatData (data) {
      if (data) {
        return moment(data).format('DD/MM/YYYY - HH:mm')
      } else {
        return 'Sem Interação'
      }
    }
  },
  watch: {
    page: function () {
      this.filtrar()
    },
    limit: function () {
      this.page = 1
      this.filtrar()
    }
  },
  computed: {
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('DD/MM/YYYY') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    // this.limitarRegistrosParaResolucao()
    this.filtrar()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    limitarRegistrosParaResolucao () {
      // Ajuste da quantidade de itens do grid para a resolução da tela
      // const h = this.$vuetify.breakpoint.height
      // console.log(h)
      // if (h < 1000) {
      //   this.limit = 20
      // } else {
      //   this.limit = 30
      // }
    },
    limparFiltros () {
      this.page = 1
      this.filtros = {}
      this.filtroData = false
      this.filtrar()
    },
    async exportarExcel () {
      this.loading = true
      setTimeout(async () => {
        this.montarFiltroComposto()
        const csvString = await excelCampanhaLogs(this.querySerialize('filtro', this.filtroComposto))
        const universalBOM = '\uFEFF'
        this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
        this.loading = false
        this.dialogExcel = true
        this.downloadExcel = true
      }, 700)
    },
    async pesquisar () {
      this.loading = true
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      const pesquisa = []
      if (this.textoPesquisa.length) pesquisa.push({ field: 'todos', value: this.textoPesquisa })
      pesquisa.push({ field: 'tipofixo', value: "('1','2','3')" })
      this.logs = await list2('/crm/campanhalogsfiltro', { tipo: 'pesquisa', query: this.serializePesquisa('pesquisa', pesquisa) }, paginate)
      this.loading = false
    },
    async filtrar () {
      this.loading = true
      this.filtros.tipofixo = "('1','2','3')"
      this.montarFiltroComposto()
      const obj = {
        tipo: 'filtro',
        query: this.querySerialize('filtro', this.filtroComposto)
      }
      const paginate = {
        page: this.page,
        limit: this.limit
      }
      try {
        this.logs = await list2('/crm/campanhalogsfiltro', obj, paginate)
        this.dialogFiltros = false
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    async montarFiltroComposto () {
      this.filtroComposto = []
      const keys = Object.keys(this.filtros)
      for (let i = 0; i < keys.length; i++) {
        if (!this.filtros[keys[i]] || this.filtros[keys[i]] === '') { continue }
        if (typeof this.filtros[keys[i]] === 'object' && !this.filtros[keys[i]].length) { continue }
        if (this.filtros[keys[i]]) {
          const type = this.filtros[keys[i]].length ? typeof this.filtros[keys[i]][0] : typeof this.filtros[keys[i]]
          this.filtroComposto.push({ field: keys[i], value: this.filtros[keys[i]], type })
        }
      }
      if (this.filtroData) {
        this.filtroComposto.push({ field: 'dataInicial', value: this.dataInicial + ' 00:00:00' })
        this.filtroComposto.push({ field: 'dataFinal', value: this.dataFinal + ' 23:59:59' })
      }
    },
    querySerialize (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) query = query + nome
        query = query + encodeURIComponent(`[${i}]`) + '=' + encodeURIComponent(JSON.stringify(filtro[i]))
        if (i < filtro.length - 1) query = query + `&${nome}`
      }
      query = query.replace(/%2C/g, ',')
      return query
    },
    serializePesquisa (nome, filtro) {
      let query = ''
      for (let i = 0; i < filtro.length; i++) {
        if (i === 0) {
          query = query + nome + '%5B0%5D' + '=' + '%5B' + encodeURIComponent(JSON.stringify(filtro[i]))
        } else {
          query = query + encodeURIComponent(',') + encodeURIComponent(JSON.stringify(filtro[i]))
        }
      }
      return query + '%5D'
    }
  }
}
</script>

<style scoped>
.fs-searchfield .v-input__icon--append .v-icon {
  margin-top: -6px;
  font-size: 23px !important;
}
.fs-searchfield .v-input__icon--append .v-icon:hover {
  color: black;
}
textarea:focus, input:focus, select:focus, button:focus {
  box-shadow: 0 0 0 0;
  border: 0;
  outline: 0;
}
.fs-btn-limit {
  font-size: 11px !important;
}
.v-input--selection-controls.v-input .v-label {
  padding-top: 9px !important;
  font-size: 12px !important;
}
.fs-topbar-right {
  text-align: right;
}
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}
.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
.fs-row-campanha-selec {
  background-color: rgba(253, 210, 182, 0.432);
}
.fs-checkbox-filtros {
  padding-top: 0px !important;
  margin-left: -5px !important;
  margin-top: -5px !important;
  height: 30px !important;
}
.fs-div-checkbox-filtro {
  background-color: #F8F8F8;
  border: 1px solid #CCC;
  border-radius: 4px;
  padding: 5px 10px 2px 10px;
  margin-top: 10px;
  text-align: center;
  border-radius: 4px;
}
.fs-tr-logs:hover {
  background-color: rgb(233, 233, 233);
}
td {
  height: 33px !important;
}
</style>
